import { Check, Minus } from "lucide-react";

const rows = [
  { name: "Daily order summary", basic: true, pro: true, premium: true },
  { name: "Weekly revenue report", basic: true, pro: true, premium: true },
  { name: "Monthly order volume", basic: true, pro: true, premium: true },
  { name: "Service popularity report", basic: false, pro: true, premium: true },
  { name: "Customer retention report", basic: false, pro: true, premium: true },
  { name: "Detergent usage alerts", basic: false, pro: true, premium: true },
  { name: "Customer location heatmap", basic: false, pro: true, premium: true },
  { name: "Full business intelligence dashboard", basic: false, pro: false, premium: true },
  { name: "Monthly CEO performance report", basic: false, pro: false, premium: true },
  { name: "Expansion readiness score", basic: false, pro: false, premium: true },
];

const Cell = ({ on }) =>
  on ? (
    <span className="inline-flex w-7 h-7 rounded-full bg-[#E8F8F5] items-center justify-center">
      <Check className="w-4 h-4 text-[#1ABC9C]" />
    </span>
  ) : (
    <Minus className="w-5 h-5 text-[#CBD5E1]" />
  );

export default function Reporting() {
  return (
    <section id="reporting" data-testid="reporting-matrix-section" className="bg-[#F8FAFC] py-16 sm:py-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <span className="inline-block text-xs font-bold uppercase tracking-widest text-[#1ABC9C] bg-[#E8F8F5] px-4 py-1.5 rounded-full mb-4">Reporting</span>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#2C3E50] max-w-2xl">
          Reports that explain your business in plain language
        </h2>
        <p className="mt-4 text-lg text-[#5D6D7E] leading-relaxed max-w-2xl">
          Every plan comes with clear reports delivered to you. Higher plans unlock deeper insights:
        </p>
        <div className="mt-10 overflow-x-auto rounded-2xl border border-[#E2E8F0] bg-white shadow-sm">
          <table data-testid="reporting-table" className="w-full min-w-[560px] text-left">
            <thead>
              <tr className="bg-[#1B4F72] text-white">
                <th className="px-6 py-4 font-display font-bold text-base">Report</th>
                <th className="px-6 py-4 font-display font-bold text-base text-center w-28">Basic</th>
                <th className="px-6 py-4 font-display font-bold text-base text-center w-28 bg-[#246693]">Pro</th>
                <th className="px-6 py-4 font-display font-bold text-base text-center w-28">Premium</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={i} data-testid={`reporting-row-${i}`} className={i % 2 === 0 ? "bg-white" : "bg-[#F8FAFC]"}>
                  <td className="px-6 py-3.5 text-base text-[#2C3E50]">{r.name}</td>
                  <td className="px-6 py-3.5 text-center"><Cell on={r.basic} /></td>
                  <td className="px-6 py-3.5 text-center bg-[#EBF5FB]/60"><Cell on={r.pro} /></td>
                  <td className="px-6 py-3.5 text-center"><Cell on={r.premium} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
